(function() {
  var storageKey = 'malacasa:discount-offer';
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var savedOffer = null;
  var sessionRequest = null;

  try {
    savedOffer = JSON.parse(window.sessionStorage.getItem(storageKey));
  } catch (error) {
    savedOffer = null;
  }

  function saveOffer(offer) {
    savedOffer = offer;
    try {
      if (offer) {
        window.sessionStorage.setItem(storageKey, JSON.stringify(offer));
      } else {
        window.sessionStorage.removeItem(storageKey);
      }
    } catch (error) {}
  }

  function getSavedOffer() {
    if (!savedOffer) return null;
    if (savedOffer.root !== root || !savedOffer.code || !savedOffer.expiresAt || savedOffer.expiresAt <= Date.now()) {
      saveOffer(null);
      return null;
    }
    return savedOffer;
  }

  function discountUrl(code, redirect) {
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
  }

  function applyDiscount(code) {
    if (sessionRequest) sessionRequest.controller.abort();
    var controller = new AbortController();
    var timer = window.setTimeout(function() { controller.abort(); }, 6000);
    var request = { code: code, controller: controller };
    request.promise = fetch(discountUrl(code, root + 'cart.js'), {
      credentials: 'same-origin',
      signal: controller.signal
    }).then(function(response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).finally(function() {
      window.clearTimeout(timer);
      if (sessionRequest === request) sessionRequest = null;
    });
    sessionRequest = request;
    return request.promise;
  }

  function rememberOffer(button) {
    var offer = button.closest('[data-market-discount-offer]');
    var endsAt = Number(offer.getAttribute('data-offer-ends-at')) * 1000;
    saveOffer({
      code: button.getAttribute('data-discount-code'),
      root: root,
      expiresAt: Math.min(Date.now() + 86400000, endsAt || Infinity)
    });

    applyDiscount(savedOffer.code).then(function(cart) {
      if (cart.item_count > 0) document.dispatchEvent(new CustomEvent('cart:build'));
    }).catch(function() {});
  }

  function legacyCopy(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    var copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    document.body.removeChild(textarea);
    return copied ? Promise.resolve() : Promise.reject();
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function() {
        return legacyCopy(text);
      });
    }

    return legacyCopy(text);
  }

  function resetCopyState(offer) {
    var button = offer.querySelector('[data-discount-copy]');
    if (!button) return;

    var label = button.querySelector('[data-discount-copy-label]');
    window.clearTimeout(button.discountCopyTimer);
    button.classList.remove('is-copied');
    if (label) label.textContent = button.getAttribute('data-copy-label');
    var status = offer.querySelector('[data-discount-status]');
    if (status) status.textContent = '';
  }

  function supportsVariant(offer, variantId) {
    if (!variantId) return false;
    var endsAt = Number(offer.getAttribute('data-offer-ends-at')) * 1000;
    if (endsAt && endsAt <= Date.now()) return false;
    var allowedIds = offer.getAttribute('data-allowed-variant-ids');
    if (!allowedIds) return true;

    return allowedIds.split(',').indexOf(String(variantId)) !== -1;
  }

  function updateOfferGroup(group, variantId) {
    var offers = Array.prototype.slice.call(group.querySelectorAll('[data-market-discount-offer]'));
    var selectedOffer = null;
    var selectedPriority = -Infinity;

    offers.forEach(function(offer) {
      if (!supportsVariant(offer, variantId)) return;

      var priority = parseInt(offer.getAttribute('data-offer-priority'), 10);
      if (isNaN(priority)) priority = 0;

      if (!selectedOffer || priority > selectedPriority) {
        selectedOffer = offer;
        selectedPriority = priority;
      }
    });

    offers.forEach(function(offer) {
      var shouldHide = offer !== selectedOffer;
      if (shouldHide && !offer.hidden) resetCopyState(offer);
      offer.hidden = shouldHide;
      if (!shouldHide) {
        var price = offer.querySelector('[data-offer-price]');
        var prices = offer.querySelector('[data-offer-prices]');
        if (price && prices) {
          if (!offer.variantPrices) offer.variantPrices = JSON.parse(prices.textContent);
          price.textContent = offer.variantPrices[String(variantId)] || '';
        }
      }
    });

    group.setAttribute('data-current-variant-id', variantId || '');
  }

  function initOfferGroups() {
    document.querySelectorAll('[data-market-discount-offers]').forEach(function(group) {
      updateOfferGroup(group, group.getAttribute('data-current-variant-id'));
      var section = group.closest('.product-section');
      if (!section || section.discountOffersBound) return;
      section.discountOffersBound = true;
      section.addEventListener('variantChange', function(event) {
        var variant = event.detail && event.detail.variant;
        section.querySelectorAll('[data-market-discount-offers]').forEach(function(sectionGroup) {
          updateOfferGroup(sectionGroup, variant ? variant.id : null);
        });
      });
    });
  }

  initOfferGroups();
  getSavedOffer();
  document.addEventListener('shopify:section:load', initOfferGroups);

  function prepareCheckoutLink(event) {
    if (!event.target.closest) return;
    var link = event.target.closest('a[href]');
    var selected = getSavedOffer();
    if (!link || !selected) return;
    var url = new URL(link.discountCheckoutUrl || link.href, window.location.origin);
    if (url.origin !== window.location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    link.discountCheckoutUrl = url.pathname + url.search + url.hash;
    link.href = discountUrl(selected.code, link.discountCheckoutUrl);
  }

  document.addEventListener('click', prepareCheckoutLink);
  document.addEventListener('auxclick', prepareCheckoutLink);

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (form.discountCheckoutResuming) {
      if (!event.defaultPrevented) saveOffer(null);
      return;
    }
    var selected = getSavedOffer();
    if (!selected || event.defaultPrevented || !form.matches('form')) return;
    var action = new URL(form.action, window.location.origin);
    if (action.origin !== window.location.origin || action.pathname !== root + 'cart') return;
    var button = event.submitter || form.querySelector('[name="checkout"]');
    if (!button || button.name !== 'checkout') return;
    var terms = form.querySelector('.cart__terms-checkbox');
    if (terms && !terms.checked) return;
    event.preventDefault();
    if (form.discountCheckoutPending) return;
    form.discountCheckoutPending = true;
    button.disabled = true;

    var errorMessage = form.querySelector('[data-discount-checkout-error]');
    if (errorMessage) errorMessage.remove();
    var request = sessionRequest && sessionRequest.code === selected.code
      ? sessionRequest.promise
      : applyDiscount(selected.code);
    request.catch(function() {}).then(function() {
      form.discountCheckoutPending = false;
      button.disabled = false;
      form.discountCheckoutResuming = true;
      try {
        form.requestSubmit(button);
      } finally {
        form.discountCheckoutResuming = false;
      }
    });
  });

  document.addEventListener('click', function(event) {
    if (!event.target.closest) return;
    var button = event.target.closest('[data-discount-copy]');
    if (!button) return;

    var code = button.getAttribute('data-discount-code');
    var label = button.querySelector('[data-discount-copy-label]');
    if (!code || !label) return;
    var offer = button.closest('[data-market-discount-offer]');
    if (!supportsVariant(offer, offer.parentNode.getAttribute('data-current-variant-id'))) return;
    var status = offer.querySelector('[data-discount-status]');
    if (status) status.textContent = '';
    button.disabled = true;

    copyText(code).then(function() {
      rememberOffer(button);
      window.clearTimeout(button.discountCopyTimer);
      label.textContent = button.getAttribute('data-copied-label');
      button.classList.add('is-copied');

      button.discountCopyTimer = window.setTimeout(function() {
        label.textContent = button.getAttribute('data-copy-label');
        button.classList.remove('is-copied');
      }, 2000);
    }).catch(function() {
      if (status) status.textContent = button.getAttribute('data-copy-error');
    }).finally(function() {
      button.disabled = false;
    });
  });
})();
